import { render, staticRenderFns } from "./auto-height.vue?vue&type=template&id=06404784"
import script from "./auto-height.vue?vue&type=script&lang=js"
export * from "./auto-height.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06404784')) {
      api.createRecord('06404784', component.options)
    } else {
      api.reload('06404784', component.options)
    }
    module.hot.accept("./auto-height.vue?vue&type=template&id=06404784", function () {
      api.rerender('06404784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/auto-height.vue"
export default component.exports